import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import ResultPage from '@/components/ResultPage'

Vue.use(Router)

export default new Router({
    mode: 'history',  // 去掉路由中的#号
    routes: [
        {
            path: '/Main',
            name: 'Main',
            component: Main
        },
        {
            path: '/',
            name: 'ResultPage',
            component: ResultPage
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js